"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashNotificationMessageWithButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Text_1 = require("@smartsuite/react-ui/lib/components/typography/Text/Text");
const FlashNotificationMessageWithButton = ({ message, buttonLabel, onClick, }) => {
    return ((0, jsx_runtime_1.jsxs)("span", { className: "flash-notification-message", children: [message, (0, jsx_runtime_1.jsx)("button", { className: "flash-notification-message__button", onClick: onClick, children: (0, jsx_runtime_1.jsx)(Text_1.Text, { weight: "semibold", size: "s", color: "currentColor", children: buttonLabel }) })] }));
};
exports.FlashNotificationMessageWithButton = FlashNotificationMessageWithButton;
